import { useState } from 'react';

import { useDynamicEntityCMSDataContext, useDynamicEntityStoreContext } from '../../../contexts';

import ErrorAccordion from '../../../../error/ErrorAccordion';
import TextInput from '../../../../inputs/form-inputs/TextInput';
import ImageCard from './_image_selector_modal/ImageCard';

export default function ImageSelectorModal({ id, onChange }) {
  const [searchTerm, setSearchTerm] = useState('');

  const { images, isLoadingImages, isErrorImages, imagesError } = useDynamicEntityCMSDataContext();

  const filteredImages = images
    ? images
        .filter((img) => typeof img.name === 'string' && img.name.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => b.createdAt - a.createdAt)
    : [];

  const handleSearch = (e) => setSearchTerm(e.target.value);

  return (
    <div className="modal fade" id={`imageSelector-${id}-Modal`} tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex justify-content-between align-items-center w-100">
              <h1 className="modal-title fs-3 d-flex gap-2">
                Select an image <span className="text-muted">(Hover over the image to select)</span>
              </h1>
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={`#imageUpload-${id}-Modal`}>
                Upload
              </button>
            </div>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3">
              <TextInput placeholder="Search for an image..." onChange={handleSearch} />
              <div className="dp-image-selector-content">
                {isLoadingImages ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : filteredImages?.length ? (
                  filteredImages.map((image) => <ImageCard key={image.id} {...{ image, onChange }} />)
                ) : (
                  <div className="d-flex flex-column align-items-center justify-content-center gap-3 p-5">
                    <span>No images found</span>
                    {isErrorImages && (
                      <div style={{ width: 400 }}>
                        <ErrorAccordion id={id} error={imagesError} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
